export default Object.freeze({
  createImage : {
    method : 'POST', // @see https://fetch.spec.whatwg.org/#methods
    path   : '/images',
  },
});
